import Header1 from 'elements/Header1';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Title = Header1.extend`
  font-size: ${ds.fontSize('l')};
  line-height: ${ds.get('type.lineHeight.l')};
  margin-top: ${ds.get('metrics.l')};
  margin-bottom: ${ds.get('metrics.sm')};
  color: ${ds.brand('white')};
  
  ${media.tablet`
    align-self: top;
    font-size: ${ds.fontSize('xl')};
    margin-bottom: ${ds.get('metrics.l')};
    line-height: ${ds.get('type.lineHeight.xl')};
  `};
`;

export default Title;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/Title.jsx